import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as Yup from 'yup';
import { useFormikContext } from 'formik';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from '@yoweb/next-i18next';
import { getInitialValues } from '../QuestionElements';
import { I_DO_NOT_KNOW_ID } from '@poplar/constants/intake';
import { useIntlMeta } from '@yoweb/ui/hooks/useIntlMeta';
import { usePreferredCurrency } from '@poplar/hooks/usePreferredCurrency';
import Checkbox from './Checkbox';
import { jsx as _jsx } from "react/jsx-runtime";
export var getIDoNotKnowInitialValues = function getIDoNotKnowInitialValues(idonotknowAnswer) {
  var _idonotknowAnswer$ans, _idonotknowAnswer$ans2;

  return (_idonotknowAnswer$ans = idonotknowAnswer === null || idonotknowAnswer === void 0 ? void 0 : (_idonotknowAnswer$ans2 = idonotknowAnswer.answeredValue) === null || _idonotknowAnswer$ans2 === void 0 ? void 0 : _idonotknowAnswer$ans2.value) !== null && _idonotknowAnswer$ans !== void 0 ? _idonotknowAnswer$ans : false;
};
export var getIDoNotKnowValidationSchema = function getIDoNotKnowValidationSchema() {
  return Yup["boolean"]().oneOf([true]);
};
export var IDoNotKnowElement = function IDoNotKnowElement(_ref) {
  var id = _ref.id;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(Checkbox, {
    id: id,
    name: id,
    children: t('task-intake-do-not-know', {
      ns: 'common'
    })
  });
};
export var ResetFormOnIDoNotKnow = function ResetFormOnIDoNotKnow(_ref2) {
  var _values$question$id2;

  var question = _ref2.question;

  var _useFormikContext = useFormikContext(),
      values = _useFormikContext.values,
      resetForm = _useFormikContext.resetForm,
      setValues = _useFormikContext.setValues;

  var _useState = useState(),
      backupValues = _useState[0],
      setBackupValues = _useState[1];

  var _useIntlMeta = useIntlMeta(),
      country = _useIntlMeta.country,
      locale = _useIntlMeta.locale;

  var currency = usePreferredCurrency(); // Need to get empty initialValues, otherwise if user goes back in the steps
  // the fields will be filled with the previous values
  // when the user clicks on "I don't know"

  var initialValues = useMemo(function () {
    return getInitialValues(question, {
      locale: locale,
      currency: currency,
      country: country
    });
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [question]);
  useEffect(function () {
    var _values$question$id;

    if ((_values$question$id = values[question.id]) !== null && _values$question$id !== void 0 && _values$question$id[I_DO_NOT_KNOW_ID] && initialValues) {
      setBackupValues(values);
      setValues(_objectSpread(_objectSpread({}, values), {}, _defineProperty({}, question.id, _objectSpread(_objectSpread({}, initialValues[question.id]), {}, _defineProperty({}, I_DO_NOT_KNOW_ID, true)))));
    } else if (backupValues) {
      setValues(_objectSpread(_objectSpread({}, values), {}, _defineProperty({}, question.id, _objectSpread(_objectSpread({}, backupValues[question.id]), {}, _defineProperty({}, I_DO_NOT_KNOW_ID, false)))));
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [(_values$question$id2 = values[question.id]) === null || _values$question$id2 === void 0 ? void 0 : _values$question$id2[I_DO_NOT_KNOW_ID], resetForm, setValues]); // Reset backup values when question changes

  useEffect(function () {
    setBackupValues(undefined);
  }, [question]);
  return null;
};